export const getters = {
   systemRoles: state => state.roles,
   systemRole: state => state.systemRole
}
export default getters


// WEBPACK FOOTER //
// ./src/vuex/modules/roles/getters.js